import * as Turbo       from '@hotwired/turbo'
// import { gsap, Power2 } from 'gsap'
import 'lazysizes'
// import 'lazysizes/plugins/blur-up/ls.blur-up';
import 'unfetch'
import '../scss/index.scss'

Turbo.setProgressBarDelay(0)
Turbo.start()

const appLoad = new CustomEvent('app:load')

document.addEventListener('turbo:visit', () =>
{
	/*gsap.to(document.body, {
	 opacity: 0,
	 duration: .5,
	 ease: Power2.easeOut
	 })*/
})

document.addEventListener('turbo:load', () =>
{
	/*gsap.to(document.body, {
	 opacity: 1,
	 duration: .5,
	 ease: Power2.easeOut
	 })*/
	
	document.dispatchEvent(appLoad)
})
